import { View, Image, Text } from '@react-pdf/renderer'
import { styles } from '../styles'
import { WORKER_URL } from '../constants'

// Renders a single row of photos (2 photos side by side)
function PhotoRow({ photos, categoryCode, startNumber }) {
  return (
    <View style={styles.photoRow} wrap={false}>
      {photos.map((photo, photoIndex) => {
        // Use local base64 if available, otherwise fetch from R2
        const imageUrl = photo.imageData || `${WORKER_URL}/api/photos/${photo.id}/image`
        return (
          <View key={photo.id} style={styles.photoContainer}>
            <Image src={imageUrl} style={styles.photo} />
            <Text style={styles.photoLabel}>
              {categoryCode}-{startNumber + photoIndex}
            </Text>
          </View>
        )
      })}
      {/* Empty placeholder if odd number of photos */}
      {photos.length === 1 && <View style={styles.photoContainer} />}
    </View>
  )
}

// First row of photos - stays with title/comment
export function FirstPhotoRow({ photos, categoryCode }) {
  if (!photos || photos.length === 0) return null

  const firstRow = photos.slice(0, 2)

  return (
    <View style={{
      ...styles.photoSection,
      borderTopWidth: 1,
      borderTopColor: '#999',
    }}>
      <PhotoRow photos={firstRow} categoryCode={categoryCode} startNumber={1} />
    </View>
  )
}

// Remaining photo rows (3+) - can flow across pages
export function RemainingPhotoRows({ photos, categoryCode }) {
  if (!photos || photos.length <= 2) return null

  const remainingPhotos = photos.slice(2)

  // Create rows of 2 photos each
  const rows = []
  for (let i = 0; i < remainingPhotos.length; i += 2) {
    rows.push(remainingPhotos.slice(i, i + 2))
  }

  // Each row is wrapped in wrap={false} to keep pairs together
  // But overall section can break across pages
  // No extra padding - parent provides it
  return (
    <>
      {rows.map((row, rowIndex) => (
        <PhotoRow
          key={rowIndex}
          photos={row}
          categoryCode={categoryCode}
          startNumber={3 + rowIndex * 2}
        />
      ))}
    </>
  )
}

// Legacy export for backwards compatibility
export function PhotoGrid({ photos, categoryCode }) {
  if (!photos || photos.length === 0) return null

  const rows = []
  for (let i = 0; i < photos.length; i += 2) {
    rows.push(photos.slice(i, i + 2))
  }

  return (
    <View style={{
      ...styles.photoSection,
      borderTopWidth: 1,
      borderTopColor: '#999',
    }}>
      {rows.map((row, rowIndex) => (
        <PhotoRow
          key={rowIndex}
          photos={row}
          categoryCode={categoryCode}
          startNumber={rowIndex * 2 + 1}
        />
      ))}
    </View>
  )
}

export default PhotoGrid
